import { Form, Formik } from "formik";
import { Col, Row } from "react-bootstrap";
import { CommonButton } from "components/UiElement";
import { Input as TextInput } from "../../../Antd";
import validation from "./validation";

export default function ManageSubscriptionForm({
  packageModalHide,
  packages,
  onSubmit,
  t,
}) {
  let initialValues = {
    name: packages?.name || "",
    amount: packages?.amount || "",
    storage: packages?.storage || "",
  };

  return (
    <>
      <Formik
        initialValues={{ ...initialValues }}
        onSubmit={(e) => onSubmit(e)}
        validationSchema={validation()}
        enableReinitialize
      >
        {(props) => {
          return (
            <Form>
              <Row className="gy-3">
                <Col sm="6">
                  <div className="form-group">
                    <label>
                      {t("text.adminManageSubscription.packageName")}
                    </label>
                    <TextInput
                      id="name"
                      name="name"
                      className="form-control"
                      type="text"
                      placeholder={t(
                        "text.adminManageSubscription.packageNamePlaceholder"
                      )}
                      setFieldValue={props.handleChange}
                    />
                  </div>
                </Col>
                <Col sm="6">
                  <div className="form-group">
                    <label>
                      {" "}
                      {t("text.adminManageSubscription.storageLabel")}
                    </label>
                    <TextInput
                      id="storage"
                      name="storage"
                      className="form-control"
                      type="text"
                      placeholder={t(
                        "text.adminManageSubscription.storagePlaceholder"
                      )}
                      setFieldValue={props.handleChange}
                    />
                  </div>
                </Col>
                <Col sm="6">
                  <div className="form-group">
                    <label>
                      {" "}
                      {t("text.adminManageSubscription.packagePriceLabel")}
                    </label>
                    <TextInput
                      id="amount"
                      name="amount"
                      className="form-control"
                      type="text"
                      placeholder={t(
                        "text.adminManageSubscription.packagePricePlaceholder"
                      )}
                      setFieldValue={props.handleChange}
                    />
                  </div>
                </Col>
              </Row>
              <div className="d-flex align-items-center justify-content-end mt-3">
                <CommonButton className="btn btn-primary me-2" type="submit">
                  {t("text.common.update")}
                </CommonButton>

                <CommonButton
                  href="#"
                  onClick={() => packageModalHide()}
                  className="btn btn-outline-primary"
                >
                  {t("text.common.cancel")}
                </CommonButton>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}
